<div class="cppLanding">
  <div class="fulfillmentLanding cpp-wrapper">
    <div *ngIf="haveBannerMessage" class="status-bar">
      We’ve reformulated three mid-tier adjuvants for Crop Year 2025 to optimize the formulas and better align to the OPTIFY brand. Listed below are the products that will be phased out along with the names of the new equivalent OPTIFY products that you can order moving forward.
      <br />Between -> OPTIFY HSCOC
      <br /> Succeed Ultra -> OPTIFY HSMSO
      <br />OPTIFY A20 -> OPTIFY A
    </div>
    <!-- style="overflow:auto;margin-right:-15px;"-->
    <div class="cppLandingPage">
      <div class="row">
        <div class="col-md-12 col-lg-12 margin-l0 cppTopSec">
          <h3>
            Crop Protection Orders
          </h3>
        </div>
      </div>
      <div class="form-sec">
        <div class="row margin-t10 margin-b10 margin-r0">
          <div class="col-sm-12 col-md-9 col-lg-9 col-xl-10 smallPadRgt0 margin-l0">
            <div class="row search-box-outer ">
              <div class="col-4 col-md-4 col-lg-3 padding-r0 category-drop-outer borderRight">

                <div class="category-dropdown material-select">
                  <!--<ng-select [items]="searchTypeList"
                           name="ddlProductSearch"
                           [(ngModel)]="selectedValue"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           bindValue="value"
                           labelForId="name"
                           [searchable]="false"
                           (change)="retainFilter(null, ' ')">
                </ng-select>-->
                  <ng-select [(ngModel)]="selectedValue"
                             name="ddlProductSearch"
                             [virtualScroll]="true"
                             [closeOnSelect]="true"
                             [selectOnTab]="true"
                             [clearable]="false"
                             [searchable]="false"
                             (change)="retainFilter(null, ' ')"
                             data-testid="ddl-cpp-filter">
                    <ng-option *ngFor="let data of searchTypeList;let i=index" [value]="data">
                      <span [attr.data-testid]="'ddl-cpp-filter_'+i">{{data}}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="col-8 col-md-8 col-lg-9 padding-l4 padding-r0 ">
                <div class="row material-select reports-search-filter">

                  <div #productSearch *ngIf="selectedValue === 'Product Name'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-product-search" (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.ProductName"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number' && tabIndex >= 2"
                             [items]="itemList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.ItemNo"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="retainFilter(itemNo,'ItemNo')"
                             data-testid="ddl-itemno-search">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template" [attr.data-testid]="'ddl-itemno-search_'+index">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number' && tabIndex < 2"
                             [items]="itemListCPP"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.ItemNo"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="retainFilter(itemNo,'ItemNo')"
                             data-testid="ddl-itemno-search">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template" [attr.data-testid]="'ddl-itemno-search_'+index">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #AccountNo *ngIf="selectedValue === 'Account' && isEvolveAccountRestriction == true"
                             [items]="ddlAccounts"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.AccountNo"
                             [virtualScroll]="true"
                             bindLabel="accountNameCityState"
                             bindValue="accountNumber"
                             [closeOnSelect]="true"
                             [searchFn]="accountSearchFn"
                             (change)="retainFilter(null, ' ')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row" *ngIf="item.accountNumber!=-1">
                          <div class="col-md-8">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.accountName}}
                            </h4>
                            <p class="address" [ngOptionHighlight]="search">
                              {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                            </p>
                            <p class="phoneNo" [ngOptionHighlight]="search">
                              {{item.primaryPhoneNumber}}
                            </p>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Account #: {{item.accountNumber}}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="row" *ngIf="item.accountNumber==-1">
                          <div class="col-md-8">
                            <h4 class="name" [ngOptionHighlight]="search">
                              {{item.accountName}}
                            </h4>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Account #: {{item.accountNumber}}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                  <div #productSearch *ngIf="selectedValue === 'Account No' " class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-account-no-search" (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.TxtAccountNo"
                                 placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div #productSearch *ngIf="selectedValue === 'Account Name'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-account-name-search" (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.AccountName"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Order Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput data-testid="ddl-order-date-from-search" [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromOrderDateFilter"
                               readonly [(ngModel)]="productFilters.FromOrderDate" (dateChange)="retainFilter(null, ' ');validateOrderDateFilter('fromOrderDate', $event);">
                        <mat-datepicker-toggle data-testid="ddl-order-date-from-icon" matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 maturitySelect" *ngIf="selectedValue === 'Order Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput data-testid="ddl-order-date-to-search" [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toOrderDateFilter"
                               readonly [(ngModel)]="productFilters.ToOrderDate" (dateChange)="retainFilter(null, ' ');validateOrderDateFilter('toOrderDate', $event);">
                        <mat-datepicker-toggle data-testid="ddl-order-date-to-icon" matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Requested Arrival Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput data-testid="ddl-requested-from-search" [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromRequestedDeliveryDateFilter"
                               readonly [(ngModel)]="productFilters.FromRequestedDeliveryDate" (dateChange)="retainFilter(null, ' ');validateRequestedDeliveryDateFilter('fromRequestedDeliveryDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker" data-testid="ddl-requested-from-icon"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 maturitySelect" *ngIf="selectedValue === 'Requested Arrival Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput data-testid="ddl-requested-to-search" [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toRequestedDeliveryDateFilter"
                               readonly [(ngModel)]="productFilters.ToRequestedDeliveryDate" (dateChange)="retainFilter(null, ' ');validateRequestedDeliveryDateFilter('toRequestedDeliveryDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker" data-testid="ddl-requested-to-icon"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div *ngIf="selectedValue == 'Sales Order Number'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-sales-order-search" (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.WinfieldReferenceNumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="selectedValue == 'Order ID'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-order-id-search" (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.WebOrderNumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="selectedValue == 'Customer PO#'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-customer-po-search" (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.CustomerPONumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-select #processingStatus name="ddlItemNoSearch" *ngIf="selectedValue === 'Status'"
                             [items]="processingStatusList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.ProcessingStatus"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="retainFilter(processingStatus,'ProcessingStatus')"
                             data-testid="ddl-status-search">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template" [attr.data-testid]="'ddl-status-option_'+index">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <div #productSearch *ngIf="selectedValue === 'Quote Number'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.QuoteNumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Close Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromCloseDateFilter"
                               readonly [(ngModel)]="productFilters.FromCloseDate" (dateChange)="retainFilter(null, ' ');validateCloseDateFilter('fromCloseDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 maturitySelect" *ngIf="selectedValue === 'Close Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toCloseDateFilter"
                               readonly [(ngModel)]="productFilters.ToCloseDate" (dateChange)="retainFilter(null, ' ');validateCloseDateFilter('toCloseDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Quote Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromQuoteDateFilter"
                               readonly [(ngModel)]="productFilters.FromQuoteDate" (dateChange)="retainFilter(null, ' ');validateQuoteDateFilter('fromQuoteDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 maturitySelect" *ngIf="selectedValue === 'Quote Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toQuoteDateFilter"
                               readonly [(ngModel)]="productFilters.ToQuoteDate" (dateChange)="retainFilter(null, ' ');validateQuoteDateFilter('toQuoteDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <ng-select #status name="ddlItemNoSearch" *ngIf="selectedValue === 'Quote Status'" [items]="quoteStatusList"
                             placeholder="Search..." class="custom-select-grower" [multiple]="true" [hideSelected]="true"
                             [(ngModel)]="productFilters.Status" [virtualScroll]="true" bindLabel="value" bindValue="value"
                             [closeOnSelect]="true" [searchFn]="filterSearchFn" (change)="retainFilter(status,'Status')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #blanketOrderStatus name="ddlItemNoSearch" *ngIf="selectedValue === 'Early Advantage Order Status'"
                             [items]="blanketOrderStatusList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.BlanketOrderStatus"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="retainFilter(blanketOrderStatus,'BlanketOrderStatus')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #blanketOrderStatus name="ddlOrderStatusSearch" *ngIf="selectedValue === 'Early Advantage Draft Order Status'"
                             [items]="blanketOrderDraftStatusList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.BlanketOrderStatus"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="retainFilter(blanketOrderStatus,'BlanketOrderStatus')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <div *ngIf="selectedValue == 'Early Advantage Order Number'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="retainFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.BlanketOrderNumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Early Advantage Order Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromBlanketOrderDateFilter"
                               readonly [(ngModel)]="productFilters.FromBlanketOrderDate" (dateChange)="retainFilter(null, ' ');validateBlanketOrderDateFilter('fromBlanketOrderDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 maturitySelect" *ngIf="selectedValue === 'Early Advantage Order Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toBlanketOrderDateFilter"
                               readonly [(ngModel)]="productFilters.ToBlanketOrderDate" (dateChange)="retainFilter(null, ' ');validateBlanketOrderDateFilter('toBlanketOrderDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 col-xl-2 search-btn-outer text-right xs-pl-0 lg-pl-60  md-pl-40 md-pr-0">
            <div class="row">
              <div class="col-sm-12 col-md-6  xs-pr-0 md-pr-10 ipadpadding">
                <div class="search-btn xs-full-width mobile-pl-5">
                  <button mat-raised-button class="btns" data-testid="ddl-cpp-search" (click)="retainFilter(null, ' ');getCppOrders();" color="primary">Search</button>
                </div>
              </div>
              <div class="col-sm-12 col-md-6  xs-pr-0 md-pr-10 ipadpadding" *ngIf="IsMobile">
                <div class="search-btn xs-full-width mobile-pl-5">
                  <button mat-raised-button class="btns" (click)="createNewOrder()" color="primary">Create New Order</button>
                </div>
              </div>
              <div class="col-sm-12 col-md-6  xs-pl-0 md-pl-10 xs-pr-0 md-pr-10 ipadPadding">
                <div class="search-btn xs-full-width mobile-pl-10">
                  <button data-testid="ddl-cpp-export" mat-raised-button class="btns margin-t12 d-none d-sm-none sm-hide d-md-block"
                          [disabled]="((tabIndex == 0 && placedCPPOrdersDataSource?.data.length <= 0)
                                      || (tabIndex == 1)
                                      || ((this.hasQuoteTabAccess == true && this.tabIndex == 2) && quoteCPPOrdersDataSource?.data.length <= 0))
                                      || (((this.tabIndex === 3 && this.hasQuoteTabAccess == true )|| (this.hasQuoteTabAccess == false && this.tabIndex == 2)) && blanketOrdersDataSource?.data.length <= 0)
                                      || (((this.tabIndex === 4 && this.hasQuoteTabAccess == true) || (this.hasQuoteTabAccess == false && this.tabIndex == 3)) && blanketDraftOrdersDateSource?.data.length <= 0)"
                          (click)="retainFilter(null, ' ');getExcelReport();" color="primary">
                    Export
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 padding-r0">
            <div class="chips-sec">
              <div class="row selected-chip xs-pt-0 md-pt-10">
                <div class="col-9 col-md-10 padding-l0">
                  <div>
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                </div>
                <div class="col-3 col-md-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
                  <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showNewEarlyAdvantageRequestBtn()">
          <div class="col-sm-12 col-md-8 col-lg-8 col-xl-9"
               *ngIf="showNewEarlyAdvantageRequestBtn()">
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-3 text-right pt-2">
            <div class=" xs-full-width mobile-pl-5">
              <button mat-raised-button class="btns create-blanket-btn" (click)="createNewBlanketOrder()"
                      *ngIf="!readOnlyEarlyAdvantageAccess && (showNewEarlyAdvantageRequestBtn() && eAAccountList.length > 0)" color="primary">
                Create New Early Advantage Order
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-right position-relative button-t20 d-sm-none d-none d-md-block sm-hide">
          <button *ngIf="!readOnlyAccess && tabIndex < 2 && !IsMobile" data-testid="ddl-create-new" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="createNewOrder()">Create New Order</button>
        </div>

        <div class="col-md-12 xs-mt-0 md-mt-0" [ngClass]="{'margin-t-30': (!readOnlyAccess && tabIndex < 2)}">

          <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab hideForMobile" (selectedTabChange)="tabChanged($event)" [selectedIndex]="currentTab">
            <mat-tab>
              <ng-template mat-tab-label>
                <i class="icon-ico-dealer_icon padding-t10" aria-hidden="true"></i>
                <div class="tab-head">
                  <h4>
                    Placed Orders
                  </h4>
                </div>
              </ng-template>
              <div class="fulfill-top-sec">
                <div class="row listing-action-items">
                  <div class="col-sm-4">
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-8 text-right mobile-pad-0">
                    <div class="display-ib wAuto">
                      <mat-paginator #placedCPPOrdersPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tableContainer dealertableContainer table-mobile-cppLanding">
                <table mat-table #placedCPPOrdersTable [dataSource]="placedCPPOrdersDataSource" matSort #placedCPPOrdersSort matSortDirection="desc" class="matTables">
                  <ng-container matColumnDef="webOrderNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipToLocation">Order ID</th>
                    <td mat-cell *matCellDef="let element">
                      <div class="d-block d-sm-block d-md-none sm-block">Order ID</div>
                      <div (click)="viewOrderDetail(element,false,'placed')">
                        <a>{{element.webOrderNumber}}</a>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="xs-none"> </td>
                  </ng-container>
                  <ng-container matColumnDef="purchaseOrderNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="webOrderNumber text-center ">Customer PO#</th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div class="d-block d-sm-block d-md-none sm-block">Customer PO#</div>
                      <div>
                        {{element.purchaseOrderNumber}}
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="xs-none"> </td>
                  </ng-container>

                  <ng-container matColumnDef="orderCreateDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderCreateDate  text-center  ">
                      Order Date
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div class="d-block d-sm-block d-md-none">Order Date</div>
                      {{element.orderCreateDate | date:'MM/dd/yyyy'}}
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                  </ng-container>

                  <ng-container matColumnDef="accountNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="accountNumber  text-center  ">Account #</th>
                    <td mat-cell *matCellDef="let element" class="text-center"> <div class="d-block d-sm-block d-md-none sm-block">Account #</div> {{element.accountNumber}} </td>
                    <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                  </ng-container>
                  <ng-container matColumnDef="accountName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="locationDetails text-center ">   Account Name </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="d-block d-sm-block d-md-none sm-block">Account Name</div>
                      <div class="order-info defaultCursor">
                        <p class="grower-name">
                          {{element.accountName}}
                        </p>
                        <p>{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="status text-center "> Status </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div class="d-block d-sm-block d-md-none">Status</div>
                      <div class="relative fix-status-alignment">
                        <div class="width-status">
                          <span class="">{{element.StatusList[0]}}</span>
                        </div>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="padding-l0 padding-r0 status-footer">
                      <!--Order Status :

                    <span class="order_dots relative" *ngIf="processedStatusCount> 0">
                      <span class="dot greendot"><i class="custom-tooltip">INVOICED</i></span> {{processedStatusCount}}
                    </span>
                    <span class="relative" *ngIf="unProcessedStatusCount > 0">
                      <span class="dot yellowdot"><i class="custom-tooltip">ACCEPTED</i></span> {{unProcessedStatusCount}}
                    </span>
                    <span class="relative" *ngIf="plannedStatusCount > 0">
                      <span class="dot orangedot"><i class="custom-tooltip">PLANNING</i></span> {{plannedStatusCount}}
                    </span>
                    <span class="relative" *ngIf="errorStatusCount > 0">
                      <span class="dot reddot"><i class="custom-tooltip">ERROR</i></span>{{errorStatusCount}}
                    </span>
                    <span class="relative" *ngIf="cancelledStatusCount > 0">
                      <span class="dot graydot"><i class="custom-tooltip">CANCELLED</i></span>{{cancelledStatusCount}}
                    </span>-->
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="contextMenu">
                    <th mat-header-cell *matHeaderCellDef class="actionBtn ">&nbsp;</th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div>
                        <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                          <button mat-menu-item (click)="viewOrderDetail(element,false,'placed')">View Order</button>
                          <button mat-menu-item (click)="emailOrderDetail(element)">Email Order</button>
                          <button mat-menu-item (click)="generatePdf(element)">Download PDF</button>
                          <!--<button mat-menu-item (click)="generatePdf(element)">Test PDF</button>-->
                        </mat-menu>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="placedCPPOrdersColumns;sticky:true;"></tr>
                  <tr mat-row *matRowDef="let row; columns: placedCPPOrdersColumns;"></tr>
                  <tr mat-footer-row *matFooterRowDef="placedCPPOrdersFooterColumns; sticky: true"></tr>
                </table>
                <div *ngIf="placedCPPOrdersList == undefined || placedCPPOrdersList.length == 0" class="noDataMsg">
                  <p class="padding-b47">No Record Found.</p>
                </div>
              </div>
            </mat-tab>

            <mat-tab>
              <div class="col-md-2">
                <ng-template mat-tab-label>
                  <i class="icon-ico-grower_icon padding-t10" aria-hidden="true"></i>
                  <div class="tab-head">
                    <h4>
                      Draft Orders
                    </h4>
                  </div>
                </ng-template>
              </div>

              <div class="fulfill-top-sec">
                <div class="row listing-action-items">
                  <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
                    <div class="display-ib wAuto">
                      <mat-paginator #draftCPPOrdersPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tableContainer growertableContainer table-mobile">
                <table mat-table #draftCPPOrdersTable [dataSource]="draftCPPOrdersDataSource" matSort #draftCPPOrdersSort matSortDirection="desc" class="matTables">

                  <ng-container matColumnDef="webOrderNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipToLocation">Order ID</th>
                    <td mat-cell *matCellDef="let element">
                      <div class="d-block d-sm-block d-md-none sm-block">Order ID</div>
                      <div (click)="navigateOrderDetail(element)">
                        <a>{{element.webOrderNumber}}</a>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="purchaseOrderNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="webOrderNumber text-center">Customer PO#</th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div class="d-block d-sm-block d-md-none sm-block">Customer PO#</div>
                      <div>
                        {{element.purchaseOrderNumber}}
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="orderCreateDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderCreateDate text-center">Draft Date</th>
                    <td mat-cell *matCellDef="let element" class="text-center"><div class="d-block d-sm-block d-md-none  sm-block">Draft Date</div> {{element.orderCreateDate | date:'MM/dd/yyyy'}} </td>
                    <td mat-footer-cell *matFooterCellDef class="d-none d-md-block">  </td>
                  </ng-container>
                  <ng-container matColumnDef="accountNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="accountNumber text-center">Account #</th>
                    <td mat-cell *matCellDef="let element" class="text-center"><div class="d-block d-sm-block d-md-none sm-block">Account #</div> {{element.accountNumber}} </td>
                    <td mat-footer-cell *matFooterCellDef class="d-none d-md-block">  </td>
                  </ng-container>
                  <ng-container matColumnDef="accountName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="locationDetails text-center"> Account Name </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="d-block d-sm-block d-md-none sm-block">Account Name</div>
                      <div class="order-info defaultCursor">
                        <p class="grower-name">
                          {{element.accountName}}
                        </p>
                        <p>{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                      </div>
                    </td>
                  </ng-container>

                  <!--<ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="total text-center"> Total </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span *ngIf="element !== undefined && element.total < 0">
                      ({{ element.total | number:'1.4-4' }})
                    </span>
                    <span *ngIf="element !== undefined && element.total >= 0">
                      {{ element.total | number:'1.4-4' }}
                    </span>
                  </td>
                </ng-container>-->

                  <ng-container matColumnDef="contextMenu">
                    er
                    <th mat-header-cell *matHeaderCellDef class="actionBtn">&nbsp;</th>
                    et
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div *ngIf="!readOnlyAccess">
                        <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                          <button mat-menu-item (click)="navigateOrderDetail(element)">Edit Order</button>
                          <button mat-menu-item (click)="deleteOrder(element)">Delete Order</button>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="draftCPPOrdersColumns;sticky:true;"></tr>
                  <tr mat-row *matRowDef="let row; columns: draftCPPOrdersColumns;"></tr>
                </table>
                <div *ngIf="draftCPPOrdersList == undefined || draftCPPOrdersList.length == 0" class="noDataMsg draftOrderHeight">
                  <p>No Record Found.</p>
                </div>
              </div>
            </mat-tab>

            <mat-tab *ngIf="hasQuoteTabAccess">
              <div class="col-md-2">
                <ng-template mat-tab-label>
                  <img class="chat" alt="" src="../assets/icon/svg/chat.svg">
                  <img class="chat-hover" alt="" src="../assets/icon/svg/chat-hover.svg">
                  <div class="tab-head">
                    <h4>
                      Quote Orders
                    </h4>
                  </div>
                </ng-template>
              </div>

              <div class="fulfill-top-sec">
                <div class="row listing-action-items">
                  <div class="w240 dropdownArea padding-l0 padding-r0">
                    <div class="material-select reports-search-filter wide100 dd-select xs-pl-20">
                      <ng-select name="ddlHeaderQuoteStatusSearch"
                                 [items]="headerQuoteStatusList"
                                 class="custom-select-grower padding-l10 xs-pr-5"
                                 bindLabel="value"
                                 bindValue="id"
                                 [closeOnSelect]="true"
                                 [(ngModel)]="headerQuoteStatus"
                                 [searchable]="false"
                                 [clearable]="false"
                                 (change)="filterDataGrid()">
                        <ng-template ng-label-tmp let-item="item">
                          {{item.value}}
                          <span *ngIf="item.id == 1" class="noti">{{openOrderCount}}</span>
                          <span *ngIf="item.id == 2" class="noti">{{closeOrderCount}}</span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-9 padding-r0">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                              <div class="col-3 padding-l0 text-center">
                                <span *ngIf="item.id == 1" class="noti">{{openOrderCount}}</span>
                                <span *ngIf="item.id == 2" class="noti">{{closeOrderCount}}</span>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="flex-one text-right">
                    <div class="display-ib wAuto quote-pagination">
                      <mat-paginator #quoteCPPOrdersPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tableContainer dealertableContainer table-mobile quoteTableContainer">
                <table mat-table #quoteCPPOrdersTable [dataSource]="quoteCPPOrdersDataSource" matSort #quoteCPPOrdersSort (matSortChange)="quoteSortData($event)"
                       matSortDirection="desc" multiTemplateDataRows class="matTables">

                  <ng-container matColumnDef="{{column}}" *ngFor="let column of quoteCPPOrdersColumns">
                    <div *ngIf="column == 'quoteNumber'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="quoteNumber">Quote #</th>
              </div>
              <div *ngIf="column == 'accountName'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="accountName">Account Name</th>
        </div>
        <div *ngIf="column == 'accountNumber'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="accountNumber justify-content-center-child">Account #</th></div>
        <div *ngIf="column == 'status'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="status justify-content-center-child">Status</th></div>
        <div *ngIf="column == 'quoteDate'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="quoteDate justify-content-center-child">Quote Date</th></div>
        <div *ngIf="column == 'closeDate'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="closeDat justify-content-center-child">Close Date</th></div>
        <div *ngIf="column == 'preparedBy'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="preparedBy justify-content-center-child">Prepared By</th></div>
        <div *ngIf="column == 'preparedFor'" class="d-none d-sm-none d-md-block"><th mat-header-cell *matHeaderCellDef mat-sort-header class="preparedFor justify-content-center-child">Prepared For</th></div>
        <div *ngIf="column == 'openLines'" class="d-none d-sm-none d-md-block"><th mat-header-cell *matHeaderCellDef mat-sort-header class="openLines justify-content-center-child">Open Lines</th></div>
        <div *ngIf="column == 'contextMenu'"><th mat-header-cell *matHeaderCellDef class="contextMenu">&nbsp;</th></div>

        <td mat-cell *matCellDef="let elementOuter">
          <div *ngIf="column=='quoteNumber'">
            <div class="d-block d-sm-block d-md-none sm-block">Quote #</div>
            <div (click)="viewQuoteDetails(elementOuter)">
              <a>{{elementOuter.quoteNumber}}</a>
            </div>
          </div>

          <div *ngIf="column=='accountName'" class="order-info defaultCursor">
            <div class="d-block d-sm-block d-md-none sm-block">Account Name</div>
            <p class="grower-name">
              {{elementOuter.accountName}}
            </p>
            <p>{{elementOuter.accountAddress1 || elementOuter.accountAddress2}}, {{elementOuter.accountCity}}, {{elementOuter.accountState}} {{elementOuter.accountZipCode}}</p>
          </div>

          <div *ngIf="column=='accountNumber'" class="defaultCursor text-center">
            <div class="d-block d-sm-block d-md-none sm-block">Account #</div>
            {{elementOuter.accountNumber}}
          </div>

          <div *ngIf="column=='status'" class="defaultCursor text-center">
            <div class="d-block d-sm-block d-md-none sm-block">Status</div>
            <span matTooltip="{{getStatusText(elementOuter.status)}}" [matTooltipPosition]="'right'">{{elementOuter.status}}</span>
          </div>

          <div *ngIf="column=='quoteDate'" class="defaultCursor text-center">
            <div class="d-block d-sm-block d-md-none sm-block">Quote Date</div>
            {{elementOuter.quoteDate | date:'MM/dd/yyyy'}}
          </div>

          <div *ngIf="column=='closeDate'" class="defaultCursor text-center">
            <div class="d-block d-sm-block d-md-none sm-block">Close Date</div>
            {{elementOuter.closeDate | date:'MM/dd/yyyy'}}
          </div>

          <div *ngIf="column=='preparedBy'" class="defaultCursor text-center">
            <div class="d-block d-sm-block d-md-none sm-block">Prepared By</div>
            {{elementOuter.preparedBy}}
          </div>

          <div *ngIf="column=='preparedFor'" class="defaultCursor text-center d-none d-sm-none d-md-block">
            <div class="d-block d-sm-block d-md-none sm-block">Prepared For</div>
            {{elementOuter.preparedFor}}
          </div>

          <div *ngIf="column=='openLines'" class="text-center d-none d-sm-none d-md-block">
            <div class="d-block d-sm-block d-md-none sm-block">Open Lines</div>
            {{elementOuter.openLine}}
          </div>

          <div *ngIf="column=='contextMenu'" class="text-center d-flex align-items-center">
            <span (click)="elementOuter.isExpanded = !elementOuter.isExpanded" class="xs-expand-none xs-mr-15">
              <i class="fa angle" [ngClass]="elementOuter.isExpanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </span>
            <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
              <i class="fas fa-ellipsis-v"></i>
            </button>
            <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
              <button mat-menu-item (click)="viewQuoteDetails(elementOuter)">View Quote</button>
              <button mat-menu-item (click)="viewQuoteOrders(elementOuter)">View Quote Orders</button>
              <button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="viewQuoteConsolidatedOrder(elementOuter)">Consolidated Order View</button>
              <button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="generateQuotePdf(elementOuter)">Download PDF</button>
              <button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="emailQuoteOrder(elementOuter)">Email Quote Orders</button>
            </mat-menu>
          </div>
        </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="quoteCPPOrdersColumns.length" class="innerTable">
            <div class="example-element-detail" *ngIf="element.cppOrdersDataSource?.data.length; else noInnerData" [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'">
              <div class="inner-table" id="inner-table" *ngIf="element.isExpanded">
                <table #innerTables mat-table #innerSort="matSort" [dataSource]="element.cppOrdersDataSource" matSort class="matTables">
                  <ng-container matColumnDef="{{innerColumn}}" *ngFor="let innerColumn of quoteCPPOrdersInnerColumns">
                    <div *ngIf="innerColumn == 'orderId'"><th mat-header-cell *matHeaderCellDef class="orderIdCol">Order Id</th>
              </div>
              <div *ngIf="innerColumn == 'customerPO'">
          <th mat-header-cell *matHeaderCellDef class="customerPOCol text-center xs-pr-15">Customer PO</th>
      </div>
      <div *ngIf="innerColumn == 'deliverTo'"><th mat-header-cell *matHeaderCellDef class="deliverToCol text-left">Ship/Deliver To</th></div>
      <div *ngIf="innerColumn == 'accountId'"><th mat-header-cell *matHeaderCellDef class="accountIdCol text-center xs-pr-15">Account ID</th></div>
      <div *ngIf="innerColumn == 'draftDate'"><th mat-header-cell *matHeaderCellDef class="draftDateCol text-center xs-pr-15">Draft Date</th></div>
      <div *ngIf="innerColumn == 'orderDate'"><th mat-header-cell *matHeaderCellDef class="orderDateCol text-center xs-pr-15">Order Date</th></div>
      <div *ngIf="innerColumn == 'status'"><th mat-header-cell *matHeaderCellDef class="statusCol text-center xs-pr-15">Status</th></div>
      <div *ngIf="innerColumn == 'contextMenu'"><th mat-header-cell *matHeaderCellDef class="contextMenu text-center">&nbsp;</th></div>

      <td mat-cell *matCellDef="let elementInner" class="error-row-outer">
        <div *ngIf="innerColumn=='orderId'" class="defaultCursor">
          {{elementInner.orderId}}
        </div>

        <div *ngIf="innerColumn=='customerPO'" class="defaultCursor text-center">
          {{elementInner.customerPO}}
        </div>

        <div *ngIf="innerColumn=='deliverTo'" class="order-info defaultCursor text-left">
          <p class="grower-name">
            {{elementInner.deliverToAccountName}}
          </p>
          <p>{{elementInner.deliverToAddress1 || elementInner.deliverToAddress2}}, {{elementInner.deliverToCity}}, {{elementInner.deliverToState}} {{elementInner.deliverToZipCode}}</p>
        </div>

        <div *ngIf="innerColumn=='accountId'" class="defaultCursor text-center">
          {{elementInner.accountId}}
        </div>

        <div *ngIf="innerColumn=='draftDate'" class="defaultCursor text-center">
          {{elementInner.draftDate | date:'MM/dd/yyyy'}}
        </div>

        <div *ngIf="innerColumn=='orderDate'" class="defaultCursor text-center">
          {{elementInner.orderDate | date:'MM/dd/yyyy'}}
        </div>

        <div *ngIf="innerColumn=='status'" class="defaultCursor text-center">
          <div class="width-status xs-m-0">
            <span title="{{elementInner.orderStatus}}" *ngIf="elementInner.orderStatus=='CANCELLED'" class="dot graydot"></span>
            <span title="{{elementInner.orderStatus}}" *ngIf="elementInner.orderStatus=='ACCEPTED'" class=" dot yellowdot"></span>
            <span title="{{elementInner.orderStatus}}" *ngIf="elementInner.orderStatus=='PLANNING'" class="dot orangedot"></span>
            <span title="{{elementInner.orderStatus}}" *ngIf="elementInner.orderStatus=='ERROR'" class="dot reddot"></span>
            <span title="{{elementInner.orderStatus}}" *ngIf="elementInner.orderStatus=='INVOICED' || elementInner.orderStatus=='SHIPPED'" class="dot greendot"></span>
          </div>
        </div>

        <div *ngIf="innerColumn=='contextMenu'" class="text-center">
          <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
            <button *ngIf="headerQuoteStatus == 1" mat-menu-item (click)="editQuoteOrder(elementInner.quoteId, elementInner.cppOrderId)">Edit Order</button>
            <button *ngIf="headerQuoteStatus == 1" mat-menu-item (click)="deleteOrder(elementInner)">Delete Order</button>

            <button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="emailQuoteOrder(elementInner, false)">Email Order</button>
            <button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="viewQuoteOrder(elementInner)">View Order</button>
            <button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="generateQuotePdf(elementInner, false)">Download PDF</button>
            <!--<button *ngIf="headerQuoteStatus == 2" mat-menu-item (click)="generatePdfUrl(elementInner, false)">Test PDF</button>-->
          </mat-menu>
        </div>
      </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="quoteCPPOrdersInnerColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: quoteCPPOrdersInnerColumns;"></tr>
      </table>
    </div>
  </div>
  <ng-template #noInnerData>
    <div class="noDataMsg min-height-auto">
      <p>No Record Found.</p>
    </div>
  </ng-template>
  </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="quoteCPPOrdersColumns;sticky:true;"></tr>
  <tr mat-row *matRowDef="let element; columns: quoteCPPOrdersColumns;" [class.example-element-row]="element.quoteCPPOrdersList?.data.length"
      [class.example-expanded-row]="element.isExpanded"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" [ngClass]="{'hide': !row.isExpanded}" class="example-detail-row">
    </table>
    <div *ngIf="quoteCPPOrdersList == undefined || quoteCPPOrdersList.length == 0" class="noDataMsg">
      <p class="padding-b47">No Record Found.</p>
    </div>
</div>
            </mat-tab>
<mat-tab *ngIf="hasBlanketTabAccess">
  <div class="col-md-2">
    <ng-template mat-tab-label>
      <img class="blanket-icon" alt="" src="../assets/icon/svg/blanket-icon-tab.svg">
      <img class="blanket-hover" alt="" src="../assets/icon/svg/blanket-icon-tab-hover.svg">
      <div class="tab-head">
        <h4>
          Early Advantage Orders
        </h4>
      </div>
    </ng-template>
  </div>
  <app-blanket-order-grid *ngIf="((tabIndex === 3 && this.hasBlanketTabAccess) || (this.hasBlanketTabAccess && this.hasQuoteTabAccess == false && tabIndex == 2))"
                          (Search)="setBlanketOrderGridCount($event)"
                          [(filter)]="blanketFilter"></app-blanket-order-grid>
</mat-tab>
<mat-tab *ngIf="hasBlanketTabAccess">
  <div class="col-md-2">
    <ng-template mat-tab-label>
      <i class="icon-ico-grower_icon padding-t10" aria-hidden="true"></i>
      <div class="tab-head">
        <h4>
          Early Advantage Draft Orders
        </h4>
      </div>
    </ng-template>
  </div>
  <app-blanket-order-grid *ngIf="((tabIndex === 4 && this.hasBlanketTabAccess) || (this.hasBlanketTabAccess && this.hasQuoteTabAccess == false && tabIndex == 3))"
                          (Search)="setBlanketDraftOrderGridCount($event)"
                          [(filter)]="blanketFilter"></app-blanket-order-grid>
</mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
